import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  private validationRules: Record<string, RegExp> = {
    cfdi_uuid: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
    // RFC más flexible: 12 para persona moral, 13 para persona física.
    rfc: /^[A-Z&Ñ]{3,4}\d{6}[A-Z\d]{3}$/,
    nombre: /.{5,}/,
    // La validación de fecha ya no usará regex.
    total: /^[0-9,]+(\.\d{1,2})?$/
  };

  constructor() { }

  validateField(fieldKey: string, value: any): boolean {
    if (value === null || value === undefined || typeof value !== 'string' || value.trim() === '') {
      return false;
    }

    // Si dice explícitamente "NO ENCONTRADO" o "REVISION", es inválido
    if (value === 'NO ENCONTRADO' || value === 'REVISION_REQUERIDA') {
      return false;
    }

    // --- Lógica de Fecha Mejorada (Soporte Dual) ---
    if (fieldKey.toLowerCase().includes('fecha') || fieldKey.toLowerCase().includes('date')) {
      // 1. Intento ISO estándar (YYYY-MM-DD) - Lo que manda JS Date
      const date = new Date(value);
      if (!isNaN(date.getTime())) return true;

      // 2. Intento Formato Latino (DD/MM/YYYY) - Lo que fallaba
      const latinDateRegex = /^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/;
      if (latinDateRegex.test(value)) return true;

      return false;
    }

    let ruleKey: string;
    if (fieldKey.toLowerCase().includes('rfc')) {
      ruleKey = 'rfc';
    } else if (fieldKey.toLowerCase().includes('nombre') || fieldKey.toLowerCase().includes('razon')) {
      ruleKey = 'nombre';
    } else {
      ruleKey = fieldKey;
    }

    const regex = this.validationRules[ruleKey];
    if (!regex) {
      return true; // Si no hay regla específica, se asume válido (ej. Folios)
    }

    return regex.test(value.trim());
  }
}